import React, { FunctionComponent, PropsWithChildren } from 'react';
import { prepareProps } from '../../utils/propUtils';
import styles from './FormGroup.module.css';

export type FormGroupProps = PropsWithChildren<Record<never, never>>;

export const FormGroup: FunctionComponent<FormGroupProps> = React.memo(
  (props) => {
    const { children, ...remainingProps } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={styles.formGroup}
      >
        {children}
      </div>
    );
  }
);
